import request from '@/utils/request'

export function registerSmith(data) {
    return request({
        url: '/smith/register',
        method: 'post',
        data: data
    })
}

export function getInfo(id) {
    return request({
        url: '/smith/' + id,
        method: 'get',
    })
}

export function fetchList(params) {
    return request({
        url: '/smith/list',
        method: 'get',
        params: params
    })
}

export function updateSmith(id, data) {
    return request({
        url: '/smith/update/' + id,
        method: 'post',
        data: data
    })
}

export function updateStatus(id, params) {
    return request({
        url: '/smith/updateStatus/' + id,
        method: 'post',
        params: params
    })
}

export function deleteSmith(params) {
    return request({
        url: '/smith/delete/',
        method: 'post',
        params: params
    })
}